module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerService('googleAnalytics', {
		_included: false,
		_accounts: [],

		include: function() {
			if (this._included) {
				return;
			}

			_gaq = [];
			var ga = document.createElement('script');
			ga.type = 'text/javascript';
			ga.async = true;
			ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js';
			_gaScriptLoaded = false;
			ga.onload = function() {
				_gaScriptLoaded = true;
			};
			document.body.appendChild(ga);
			this._included = true;
		},

		setAccounts: function(accounts) {
			var typeOfArg = Object.prototype.toString.call(accounts);

			switch (typeOfArg) {
				case '[object String]':
					this._accounts = accounts.split(',');
				break;

				case '[object Array]':
					this._accounts = accounts;
				break;

				default:
					throw 'The first argument should be an array or a string, ' + typeOfArg + ' passed';
			}
		},

		getAccounts: function() {
			return this._accounts;
		},

		_query: function(par) {
			fox.each(this._accounts, function(account, index) {
				var gaPrefix = 'account' + index + '.';

				_gaq.push([gaPrefix + '_setAccount', account]);
				_gaq.push([gaPrefix + '_setSiteSpeedSampleRate', 100]);
				_gaq.push([
					gaPrefix + '_setCustomVar',
					/* This custom var is set to slot #1.  Required parameter. */
					1,
					/* The name. Required parameter. */
					'isUser',
					/* This value of the custom variable.  Required parameter. */
					fox.isEmpty(fox.site.member) ? "0" : "1",
					/* Sets the scope to page-level. */
				 	3
				]);

				// @todo move to amc
				var foxref = null;
				var acode = null;

				if (foxref = fox.cookie.get('foxref')) {
					_gaq.push([gaPrefix + '_setCustomVar', 2, 'foxref',	foxref,	3]);
				}

				if (acode = fox.cookie.get('acode')) {
					_gaq.push([gaPrefix + '_setCustomVar', 3, 'acode', acode, 3]);
				}

				var queryData = par.params;
				queryData.unshift(gaPrefix + par.method);				
				_gaq.push(queryData);
				par.params.shift();
			});
		},

		trackPageview: function(page, logPage) {
			this._query({method: '_trackPageview', params: ['/' + page]});
			// @todo move to amc
			var logPage = typeof logPage !== 'undefined' ? logPage : false;

			if (fox.isEmpty(fox.site.member)) {
				var api = new fox.Api().method('affiliate.track');
				var data = {
					page: page
				};

				var foxref = null;

				if (foxref = fox.cookie.get('foxref')) {
					data.refCode = foxref;
				}

				api.send(data, false);
			}

			if (!fox.isEmpty(fox.site.member) && logPage) {
				var api = new fox.Api().method('logger.log');
				api.send({
					index: 'McUserActivity',
					path: fox.Navigator.getAll()
				}, false);	
			}
		},

		trackTiming: function(params) {
			this._query({method: '_trackTiming', params: params});
		}
		
	});
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-services/lib/services/ga.js
// module id = 242
// module chunks = 0